let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ed18o")).then(() => parcelRequire('5szht'));